import { Inject, Injectable } from '@angular/core';
import { RelationshipsActions } from '@next/core-lib/relationships';
import { UserActions } from '@next/core-lib/user';
import { WindowServiceInjector, WindowService } from '@next/core-lib/window';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import * as settingActions from '../../../settings/store/actions/setting.actions';
import { LocationContextConfirmationService } from '../../../shared/services/location-context-confirmation.service';

@Injectable()
export class PoultryEffects {
  constructor(
    private readonly actions$: Actions,
    @Inject(WindowServiceInjector) private readonly window: WindowService,
    private readonly locationContextConfirmation: LocationContextConfirmationService,
  ) {}

  confirmLocationContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.locationInitialized, UserActions.locationChanged),
        tap(() => this.locationContextConfirmation.markConfirmed()),
      ),
    { dispatch: false },
  );

  resetLocationContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.customerChanged),
        tap(() => this.locationContextConfirmation.reset()),
      ),
    { dispatch: false },
  );

  locationInitialized$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.locationInitialized),
      switchMap((_) => {
        const path = this.window.getPath();
        const parts = path.split('/');
        parts.splice(0, 1);
        if (parts.length > 1) {
          return this.getLoadDataActions(parts[0]);
        }
        return EMPTY;
      }),
    ),
  );

  relationshipSelectedRedirect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RelationshipsActions.setRelationshipSelectedRedirect),
      switchMap(({ redirectTo }) => {
        const parts = redirectTo ? redirectTo.split('/').slice(1) : [];
        if (parts.length > 1) {
          return of(
            RelationshipsActions.setRelationshipSelectedRedirect({ redirectTo: `/${parts[0]}` }),
          );
        } else {
          return EMPTY;
        }
      }),
    ),
  );

  // eslint-disable-next-line: no-any
  getLoadDataActions(urlPart: string) {
    if (urlPart.includes('?')) {
      urlPart = urlPart.split('?')[0];
    }

    if (urlPart === 'settings') {
      return of(settingActions.loadBarnsRequest());
    }

    return of(settingActions.loadBarnsRequest());
  }
}
